/**
 * Review tags used in company-review with identical translation keys
 */
export const reviewTagsBus = [
    'driver',
    'wifi',
    'comfort',
    'luggage',
    'air_conditioning',
    'clean',
    'safe',
    'price',
    'on_time',
    'ticket',
    'schedule',
    'fast',
    'cheap',
]

export const reviewTagsFerry = [
    'ferry',
    'catamaran',
    'wifi',
    'punctual',
    'toilet',
    'cheap',
    'clean',
    'ticket',
    'schedule',
    'car',
    'restaurant',
    'bar',
]